export default (params) => Object.keys(params).map((key) => Array.isArray(params[key]) ?
  params[key].map((item, index) => `${key}[${index}]=${item}`).join('&')
  : `${key}=${params[key]}`).join('&');
